module.exports = __webpack_public_path__ + "static/media/mothersOutFront.56e3a342.png";